import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { routes } from '../../common/constants';
import { isRouteAllowed, normalizePath, useMenuPermission } from '../../shared/context/MenuPermissionContext';
import { ScreenNotAvailable } from './ScreenNotAvailable';
import { User } from '../../system/User';

const exemptRoutes = [
  routes.login,
  routes.recover_password,
  routes.politica_de_privacidad,
  routes.terminos_y_condiciones,
  routes.maintenance,
  routes.help,
  routes.activity,
  routes.activity_checker,
  routes.distribution_corrector,
  routes.dashboard,
  routes.dashboard_empresas,
  routes.dashboard_colaboradores,
  routes.dashboard_avance_por_sector,
  routes.reports,
  routes.reportsProjectDocs,
  routes.reportsMMI,
  routes.preliquidation,
  routes.liquidation,
  routes.settlement_list,
  routes.settlementView,
  routes.directSettlementView,
  routes.directSettlementView_aje,
  routes.collaborators,
  routes.notifications,
  routes.admin,
  routes.basic_inputs,
  routes.form_example,
  routes.wizard,
  routes.defense_file_assistant,
  routes.massive_defense_view,
  routes.licences_config,
  routes.cost_per_hour_view,
  routes.cost_per_hour_view_aje,
  routes.mails,
].map(normalizePath);

const publicRoutePrefixes = [
  routes.collaborator,
  routes.project,
  routes.project_config,
  routes.project_panel,
  routes.project_docs,
  routes.edit_distribution_by_period,
  routes.view_distribution_by_period,
  routes.settlement,
  routes.direct_settlement,
  routes.direct_settlement_aje,
  routes.control_doc,
  routes.massive_mail_inspector,
  routes.cost_per_hour_detail,
  routes.cost_per_hour_detail_aje,
  routes.detail_report_hours_settlement,
  routes.assist_report_hours_settlement
].map(normalizePath);

// Paneles que no estan en el menu (son pestañas de Mi panel), se restringen por perfil
const panelRoutes = [
  routes.dashboard,
  routes.dashboard_empresas,
  routes.dashboard_colaboradores,
  routes.dashboard_avance_por_sector,
].map(normalizePath);

interface IRoutePermissionsGuardProps {
  user?: User;
}

export const RoutePermissionsGuard = ({ user }: IRoutePermissionsGuardProps) => {
  const { menuUrls } = useMenuPermission();
  const { pathname } = useLocation();

  if (panelRoutes.includes(normalizePath(pathname)) && user && (user.isLiquidatorUser() || user.isTalHumUser())) {
    return <ScreenNotAvailable />;
  }

  if (exemptRoutes.includes(pathname)) return <Outlet />;
  if (!pathname.split('/')[1]) return <Outlet />;
  if (menuUrls === null) return <Outlet />;

  const isPublicWildcard = publicRoutePrefixes.some(
      (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
  if (isPublicWildcard) return <Outlet />;

  return isRouteAllowed(menuUrls, pathname) ? <Outlet /> : <ScreenNotAvailable />;
};